var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:p-12 bg-gray-100 rounded p-4"},[_c('h2',{staticClass:"text-3xl font-bold text-center text-themeColor mb-4"},[_vm._v("\n        "+_vm._s(_vm.$t('post.list.my_posts'))+"\n    ")]),_c('p',{staticClass:"text-lg text-center"},[_vm._v("\n        "+_vm._s(_vm.$t('post.list.my_posts_author'))+"\n    ")]),_c('PostsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }